import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { MemberAuthProvider } from "@/context/MemberAuthContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import { FeatureRoute } from "@/components/site/FeatureRoute";

import Home from "@/pages/Home";
import Videos from "@/pages/Videos";
import Journey from "@/pages/Journey";
import FishRoom from "@/pages/FishRoom";
import Breeding from "@/pages/Breeding";
import Business from "@/pages/Business";
import TestLab from "@/pages/TestLab";
import Community from "@/pages/Community";
import Journal from "@/pages/Journal";
import JournalDetail from "@/pages/JournalDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import ForumHome from "@/pages/forum/ForumHome";
import ForumCategory from "@/pages/forum/ForumCategory";
import ForumTopic from "@/pages/forum/ForumTopic";
import MemberAuth from "@/pages/forum/MemberAuth";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import GiveawayPage from "@/pages/admin/GiveawayPage";
import ReceiptView from "@/pages/ReceiptView";

function App() {
  return (
    <div className="App">
      <SiteSettingsProvider>
        <AuthProvider>
          <MemberAuthProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<SiteLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/videos" element={<FeatureRoute feature="youtube"><Videos /></FeatureRoute>} />
                  <Route path="/journey" element={<FeatureRoute feature="journey"><Journey /></FeatureRoute>} />
                  <Route path="/fish-room" element={<FeatureRoute feature="fish_room"><FishRoom /></FeatureRoute>} />
                  <Route path="/breeding" element={<FeatureRoute feature="breeding"><Breeding /></FeatureRoute>} />
                  <Route path="/business" element={<FeatureRoute feature="business"><Business /></FeatureRoute>} />
                  <Route path="/test-lab" element={<FeatureRoute feature="test_lab"><TestLab /></FeatureRoute>} />
                  <Route path="/community" element={<FeatureRoute feature="community"><Community /></FeatureRoute>} />
                  <Route path="/forum" element={<FeatureRoute feature="forum"><ForumHome /></FeatureRoute>} />
                  <Route path="/forum/join" element={<FeatureRoute feature="forum"><MemberAuth /></FeatureRoute>} />
                  <Route path="/forum/category/:slug" element={<FeatureRoute feature="forum"><ForumCategory /></FeatureRoute>} />
                  <Route path="/forum/topic/:id" element={<FeatureRoute feature="forum"><ForumTopic /></FeatureRoute>} />
                  <Route path="/journal" element={<FeatureRoute feature="journal"><Journal /></FeatureRoute>} />
                  <Route path="/journal/:slug" element={<FeatureRoute feature="journal"><JournalDetail /></FeatureRoute>} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/legal/:type" element={<Legal />} />
                </Route>
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/r/:fid" element={<ReceiptView />} />
                <Route
                  path="/admin/dashboard"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/finance"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/giveaway"
                  element={
                    <ProtectedRoute>
                      <GiveawayPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </MemberAuthProvider>
        </AuthProvider>
      </SiteSettingsProvider>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
